import React from 'react';
import { Typography, Grid } from '@mui/material';
import MissionCard from './missionCard';
import AssignmentIcon from '@mui/icons-material/Assignment';
const TabOne = ({
  data,
  setOpenDetail,
  setSelectedData,
  setMissionNo,
  setSelectedTask,
  setSelectedTaskDetail,
}) => {
  return (
    <Grid
      paddingRight={'20px'}
      paddingLeft={'20px'}
      container
      xs={12}
      flexDirection={'column'}
      alignItems={'center'}
    >
      {data?.items?.length > 0 ? (
        <>
          <Grid
            mb={2}
            item
            flexDirection={'row'}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={'100%'}
          >
            <Typography
              paddingRight={'20px'}
              paddingLeft={'20px'}
              marginTop={'20px'}
              variant={'subtitle2'}
              textAlign={'left'}
            >
              جمعاوری شده : {data?.collectedCount || '-'}
            </Typography>
            <Typography
              paddingRight={'20px'}
              paddingLeft={'20px'}
              marginTop={'20px'}
              variant={'subtitle2'}
              textAlign={'left'}
            >
              تحویل به انبار :{' '}
              {
                data?.deliveredToWarehouseCount || '-'}
            </Typography>
          </Grid>
          <Grid
            item
            flexDirection={'column'}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={'100%'}
          >
            {data?.items?.map((item, index) => {
              return (
                <MissionCard
                  setSelectedData={setSelectedData}
                  item={item}
                  index={index}
                  setSelectedTaskDetail={setSelectedTaskDetail}
                  setOpenDetail={setOpenDetail}
                  setSelectedTask={setSelectedTask}
                  setMissionNo={setMissionNo}
                />
              );
            })}
          </Grid>
        </>
      ) : (
        <Grid
          item
          flexDirection="column"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="200px"
        >
          <AssignmentIcon sx={{ fontSize: '80px' }} color="disabled" />
          <Typography variant="h6" color="textSecondary">
            گزارشی ثبت نشده است
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default TabOne;
